import { fetcher } from "helpers/fetcher";

import { TDeleteFileReq, TDeleteFileRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteEmployeeFile = async (payload: TDeleteFileReq) => {
  return await fetcher<TDeleteFileRes, TDeleteFileReq["data"]>(
    ENDPOINT.USER.DELETE_EMPLOYEE_FILE,
    {
      data: payload.data,
      headers: {
        [API_HEADER.USER_ID]: payload.idUser,
        [API_HEADER.VERSION]: ENDPOINT.USER.DELETE_EMPLOYEE_FILE.version,
      },
    }
  );
};

export const mutationDeleteEmployeeFile = async (payload: TDeleteFileReq) => {
  return (await deleteEmployeeFile(payload)).data.message;
};

mutationDeleteEmployeeFile._key = (payload: TDeleteFileReq) => [
  ENDPOINT.USER.DELETE_EMPLOYEE_FILE.url,
  payload,
];
